import React from 'react';
import { Route, IndexRedirect } from 'react-router';

import App from '../components/app';
import Observacio from '../components/observacio/observacio';
import Avis from '../components/avis/avis';
import Estacio from '../components/estacio/estacio';
import Usuari from '../components/usuari/usuari';
import Contacte from '../components/contacte';
import Perfil from '../components/usuari/usuariPerfil';
import Login from '../components/login/login';

import ObservacioCrearEditar from '../components/observacio/observacioIntroduccio';
import ObservacioExportacio from '../components/observacio/observacioExportacio';
import AvisIntroduccio from '../components/avis/avisIntroduccio';
import EstacioIntroduccio from '../components/estacio/estacioIntroduccio';
import EstacioDetall from '../components/estacio/estacioDetall';
import UsuariIntroduccio from '../components/usuari/usuariIntroduccio';
import UsuariDetall from '../components/usuari/usuariDetall';

import SeguretatRouter from '../components/seguretat/seguretatRouter';

import * as rutes from './routeConstants';

export default (
    <Route>
        <Route path={rutes.rutaLogin} component={Login}/>
        <Route path={rutes.rutaArrel} component={App}>
            <Route component={SeguretatRouter}>
                <IndexRedirect to={rutes.rutaObservacions} />
                <Route path={rutes.rutaObservacions} component={Observacio} />
                <Route path={rutes.rutaExportarObservacions} component={ObservacioExportacio} />
                <Route path={rutes.rutaIntroduirObservacions} component={ObservacioCrearEditar} />

                <Route path={rutes.rutaAvisos} component={Avis} />
                <Route path={rutes.rutaIntroduirAvisos} component={AvisIntroduccio} />

                <Route path={rutes.rutaEstacions} component={Estacio} />
                <Route path={rutes.rutaIntroduccioEstacions} component={EstacioIntroduccio} />
                <Route path={rutes.rutaDetallEstacions} component={EstacioDetall} />
                <Route path={rutes.rutaEdicioEstacions} component={EstacioIntroduccio} />

                <Route path={rutes.rutaUsuaris} component={Usuari} />
                <Route path={rutes.rutaIntroduccioUsuaris} component={UsuariIntroduccio} />
                <Route path={rutes.rutaDetallUsuaris} component={UsuariDetall} />
                <Route path={rutes.rutaEdicioUsuaris} component={UsuariIntroduccio} />

                <Route path={rutes.rutaContacte} component={Contacte} />
                <Route path={rutes.rutaPerfil} component={Perfil} />
            </Route>
        </Route>
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes/index.js